// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"366":"38ffd4145a0fcc81","2888":"86e433041fd83229","5405":"bb316c81c50a5d4c","9517":"b1c72a309a487d86"}[chunkId] + ".css";
};